import React from "react";
import { GenericInput } from "../inputs/GenericInput";
import { Accordion } from "./Accordion";
import "./PropertiesTable.scss";
import * as Commons from "oc-commons/Commons";

export function PropertiesTable({ node, setSelected, nodeIndex, isTopNode, seamless = false }) {
  let group = null;
  let groups = [];

  const properties = node.getProperties();

  properties
    .filter((p) => p.showInEditor === undefined || p.showInEditor(p))
    .forEach((p) => {
      if (p.group) {
        group = { ...p, props: [] };
        groups.push(group);
      } else {
        if (group == null) {
          group = { group: "", props: [] };
          groups.push(group);
        }
        group.props.push(p);
      }
    });

  groups = groups
    .map((g) => {
      let last = null;
      g.props = g.props
        .map((p) => {
          if (p.separator && last?.separator) {
            return null;
          } else {
            last = p;
            return p;
          }
        })
        .filter((p) => p != null);
      // @ts-ignore
      if (_.first(g.props)?.separator) {
        g.props = g.props.slice(1);
      }
      // @ts-ignore
      if (_.last(g.props)?.separator) {
        g.props = g.props.slice(0, -1);
      }
      return g;
    })
    .filter((g) => g.props.length != 0);

  const body = (properties) => (
    <table className="property-table">
      <tbody>
        {properties.map((p, i) => {
          if (p.render) {
            const Render = p.render;
            const props = (p.props && p.props(node, setSelected)) ?? {};
            return (
              <tr key={i}>
                <td colSpan={2}>
                  <Render {...props} nodeIndex={nodeIndex} isTopNode={isTopNode} />
                </td>
              </tr>
            );
          }
          if (p.separator) {
            return (
              <tr key={i}>
                <td colSpan={2}>
                  <hr />
                </td>
              </tr>
            );
          }
          if (p.button) {
            return (
              <tr key={i}>
                <td colSpan={2}>
                  <div
                    className="button"
                    onClick={() =>
                      p.click({
                        node,
                        setSelected,
                      })
                    }
                  >
                    {p.button}
                  </div>
                </td>
              </tr>
            );
          }
          const validState = p.validate(p);
          // console.log('validState',validState,p);
          if (p.type == "NodeList" || p.showBig) {
            return (
              <React.Fragment key={i}>
                <tr key="label">
                  <ThLabel colSpan={2} property={p} />
                </tr>
                <tr key="list">
                  <td colSpan={2}>
                    <GenericInput
                      node={node}
                      property={p}
                      nodeIndex={nodeIndex}
                      setSelected={setSelected}
                      isTopNode={isTopNode}
                    />
                  </td>
                </tr>
                {validState && !Commons.isEmpty(validState.message) && (
                  <tr key="invalid">
                    <td colSpan={2} className={validState.className}>
                      {validState.message}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          }
          return (
            <React.Fragment key={i}>
              <tr key="property">
                <ThLabel property={p} />
                <td>
                  <GenericInput
                    node={node}
                    property={p}
                    nodeIndex={nodeIndex}
                    setSelected={setSelected}
                    isTopNode={isTopNode}
                  />
                </td>
              </tr>
              {validState && !Commons.isEmpty(validState.message) && (
                <tr key="validState">
                  <th></th>
                  <td className={validState.className}>{validState.message}</td>
                </tr>
              )}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  );

  if (seamless) {
    return body(groups.flatMap((g) => g.props));
  }

  return (
    <Accordion
      key={node.uid}
      groups={groups.map((g) => ({
        key: g.group,
        title: g.group,
        open: g.open,
        body: () => body(g.props),
      }))}
      openSingleGroup={true}
    />
  );
}

function ThLabel({ property, colSpan = 1 }) {
  if (property.label === null) {
    return null;
  }
  return (
    <th colSpan={colSpan} title={property.comment}>
      {property.label ?? property.name}
    </th>
  );
}
